<!--  -->
<template>
  <div class="add_box">
    <div class="search_box">
      <div>
        <el-input
          v-model="objr.ocean_user_id"
          style="width:200px;margin-right:10px"
          placeholder="请输入巨量登录用户编号"
        />
        <!-- <el-select
          v-model="objr.account_type"
          placeholder="请选择"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select> -->
        <el-button
          type="primary"
          style="margin-left:10px"
          icon="el-icon-search"
          @click="sraw"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh"
          @click="awered"
        >重置</el-button>
      </div>
      <!-- <div>
        <el-button
          type="success"
          icon="el-icon-plus"
          @click="addbit"
        >新增</el-button>
      </div> -->
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%;margin-top:20px"
    >
      <el-table-column
        prop="ocean_user_id"
        label="巨量登录用户编号"
        align="center"
        width="300"
      />
      <el-table-column
        prop="display_name"
        label="用户名"
        align="center"
        width="300"
      >
        <template scope="scope">
          <div>{{ scope.row.display_name }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="email"
        label="邮箱"
        width="300"
        align="center"
      />
      <el-table-column
        prop="status"
        label="状态"
        align="center"
      >
        <template scope="scope">
          <div>
            <el-switch
              v-model="scope.row.monitor_report"
              :active-value="2"
              :inactive-value="1"
              active-text="已开启"
              inactive-text="未开启"
              :class="scope.row.monitor_report == 2 ? 'switch-green' : 'switch-gray'"
              @change="(val) => statusChange(val, scope.row)"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="options"
        label="操作"
        align="center"
      >
        <template scope="scope">
          <div>
            <el-button type="primary" size="mini" @click="pullAdvertiser(scope.row)">拉取广告主</el-button>
          </div>
        </template>
      </el-table-column>

    </el-table>
    <pagination-right
      ref="paginationbox"
      :total="newtotalr"
      :page-sizes="[10]"
      @size-change="fetchPageSizer($event)"
      @current-change="fetchCurrentPager"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { authuserliust, authuserupdatemonitorreport, pullAdvertiserList } from '@/api/returnPolicyList'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      dialogVisible: false,
      objr: {
        page: 1,
        page_size: 10,
        ocean_user_id: ''
        // account_type: 0
        // name: null
      },
      adtype: null,
      newtotalr: null,
      tableData: [],
      loading: false,
      options: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: 'ADX'
        },
        {
          value: 2,
          label: '变色龙'
        }
      ]
    }
  },
  created() {
    this.menuList()
  },
  // mounted() {
  //   this.init()
  // },
  beforeDestroy() {
    console.log('销毁')
    // closeSocket()
  },
  methods: {
    pullAdvertiser(row) {
      pullAdvertiserList({ ocean_user_id: row.ocean_user_id }).then(res => {
        console.log('res', res)
        this.$message({
          message: res.message,
          type: 'success'
        })
      })
    },
    async menuList() {
      // 获取列表
      this.loading = true
      const data = await authuserliust(this.objr)
      console.log('data', data)
      this.loading = false
      this.tableData = data.data.list
      this.newtotalr = data.data.total
    },
    sraw() {
      this.objr.page = 1
      // this.objr.pageSize = 10
      this.menuList()
    },
    awered() {
      this.objr.page = 1
      this.objr.ocean_user_id = ''
      // this.objr.name = ''
      this.menuList()
    },
    // 分页
    fetchPageSizer(e) {
      this.objr.pageSize = e
      this.menuList()
    },
    fetchCurrentPager(e) {
      this.objr.page = e
      this.menuList()
    },
    updatawe() {
      this.dialogVisible = false
      this.menuList()
    },
    statusChange(val, row) {
      console.log('val', val)
      authuserupdatemonitorreport({ id: row.id, monitor_report: val })
        .then(res => {
          this.$message({
            message: '设置成功',
            type: 'success'
          })
          this.menuList()
        })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.add_box {
  padding: 20px;
}
.search_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.status-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #666;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px;
}

.dot-green {
  background-color: #52c41a;
}
.dot-red {
  background-color: #ff4d4f;
}
.dot-gray {
  background-color: #d9d9d9;
}
/* 如果是在 <style scoped> 中，加上 >>> 或 /deep/ 选择内部类 */
.switch-green >>> .el-switch__core,
.switch-green /deep/ .el-switch__core {
  background-color: #13ce66 !important;
  border-color: #13ce66 !important;
}

.switch-gray >>> .el-switch__core,
.switch-gray /deep/ .el-switch__core {
  background-color: #bfbfbf !important;
  border-color: #bfbfbf !important;
}
</style>
